export const SCHEDULED_ACTOR_LOCAL_OBJECT_MODELS = Object.freeze({
  schema: "new-yokosuka-scheduled-actor-local-object-models-v1",
  evidence: [
    ".disc-work/d000-entry0-tagged-objects.json",
    ".disc-work/d000-entry1-tagged-objects.json",
    ".disc-work/d000-entry2-tagged-objects.json",
    ".disc-work/jd00-tagged-objects.json",
    ".disc-work/ju00-tagged-objects.json",
    "captures/pvr/20260724-164834-frame-5057/ram.bin",
    "tools/evidence/scheduled-actor-local-object-inventory.json",
  ],
  worlds: {
    dobuita: {
      BA00: "S3_D000_RANK301G.MT5",
      BA01: "S3_D000_RANK300G.MT5",
      BA04: "S3_D000_KAIM400G.MT5",
      BA06: "S3_D000_KBNK301G.MT5",
      BA08: "S3_D000_ATSK300G.MT5",
      BA10: "S3_D000_KAGS500G.MT5",
      BU04: "S3_D000_NEWS701G.MT5",
      BU08: "S3_D000_TBCS502G.MT5",
      EA15: "S3_D000_CUPS500G.MT5",
      EA16: "S3_D000_BRGS500G.MT5",
      KA01: "S3_D000_BRAS701G.MT5",
      SO00: "S3_D000_KHOS500G.MT5",
      SO01: "S3_D000_HOUS501G.MT5",
      SO02: "S3_D000_SOUN3004.MT5",
    },
    sakuragaoka: {
      BA00: "S3_D000_RANK301G.MT5",
      BA01: "S3_D000_RANK300G.MT5",
      BA04: "S3_D000_KAIM400G.MT5",
      BA08: "S3_D000_ATSK300G.MT5",
      BA10: "S3_D000_KAGS500G.MT5",
      BU07: "S3_JD00_HONM400G.MT5",
      KA01: "S3_D000_BRAS701G.MT5",
      SO00: "S3_D000_KHOS500G.MT5",
      SO01: "S3_D000_HOUS501G.MT5",
      SO02: "S3_D000_SOUN3004.MT5",
    },
    yamanose: {
      BA00: "S3_D000_RANK301G.MT5",
      BA01: "S3_D000_RANK300G.MT5",
      BA04: "S3_D000_KAIM400G.MT5",
      BA08: "S3_D000_ATSK300G.MT5",
      BA10: "S3_D000_KAGS500G.MT5",
      KA01: "S3_D000_BRAS701G.MT5",
    },
    mfsy: {
      BA04: "S3_D000_KAIM400G.MT5",
      BA05: "S3_MA00_KBNK302G.MT5",
      BA06: "S3_D000_KBNK301G.MT5",
      BA08: "S3_D000_ATSK300G.MT5",
      BU00: "S3_DGCT_CLIK302G.MT5",
      BU01: "S3_DGCT_PENK300G.MT5",
      BU04: "S3_D000_NEWS701G.MT5",
      BU06: "S3_MA00_SKCS501G.MT5",
      BU07: "S3_JD00_HONM400G.MT5",
      BU08: "S3_D000_TBCS502G.MT5",
      DA03: "S3_DCHA_HSJS500G.MT5",
      DE00: "S3_MA00_CAMS500G.MT5",
      DE01: "S3_MA00_YDTHI0SG.MT5",
      EA04: "S3_DCHA_TUKS701G.MT5",
      EA05: "S3_DCHA_KAYHI00G.MT5",
      EA12: "S3_DCHA_B30A006G.MT5",
      EA13: "S3_DCHA_B30A008G.MT5",
      ET00: "S3_MA00_BAMA000G.MT5",
      SN01: "S3_MA00_DAIT203G.MT5",
      SN02: "S3_MFSY_DAIT204G.MT5",
      SO01: "S3_D000_HOUS501G.MT5",
    },
    interior: {
      BU02: "S3_JOMO_HONM401G.MT5",
      BU10: "S3_JOMO_SYAT200G.MT5",
      SO01: "S3_JOMO_HOUS501G.MT5",
    },
    exterior: {
      SO01: "S3_JHD0_HOUS501G.MT5",
    },
  },
});

export default SCHEDULED_ACTOR_LOCAL_OBJECT_MODELS;
